






































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { router } from "../../_router";
import { bus } from "../../main";
import DetailsDialog from "../Dialogs/DetailsDialog.vue";
import EditDialog from "../Edit/EditDialog.vue";
import * as user from "../../_store/user.module";
import * as data from "../../_store/data.module";
import * as temp from "../../_store/temp.module";
import DownloadRecords from "../DownloadRecords.vue";
import NoteRichiestaDialog from "../Dialogs/NoteRichiestaDialog.vue"
import ReportDocDialog from "../Dialogs/ReportDocDialog.vue"
import NoteAziendeDialog from "@/components/Dialogs/NoteAziendeDialog.vue";
import { userUtils } from "../../_utils/userUtils";

@Component({
  components: {
    DetailsDialog,
    EditDialog,
    DownloadRecords,
    NoteRichiestaDialog,
    ReportDocDialog,
    NoteAziendeDialog
  }
})
export default class RequestsDataTable extends Vue {
  @Prop() params!: any;
  @Prop() createParams!: any;
  @Prop() recordType!: string;
  private anniScolastici: any[];
  private annoScolasticoFilter: any;
  private utilizzataFilter: any;
  private utilizzata: any[];
  private userInfo: any;

  private search: string;
  private loadingData: boolean;
  private showReportDialog: boolean;
  private showNoteAziendeDialog: boolean;

  constructor() {
    super();
    this.search = "";
    this.loadingData = true;
    this.annoScolasticoFilter = 0;
    this.anniScolastici = [];
    this.utilizzataFilter = "Tutte"
    this.utilizzata = ["Tutte", "Utilizzate", "Non Utilizzate"]
    this.showReportDialog = true
    this.showNoteAziendeDialog = true
    this.userInfo = {}
  }

  @Watch("annoScolasticoFilter")
  onAnnoScolasticoChange(value: string) {
    this.loadingData = true
    this.changeAnnoScolastico();
    // bus.$emit("autorizzazioneFilter", value)
  }

  @Watch("utilizzataFilter")
  onUtilizzataCHange(value: string) {
    this.filterChange();
  }

  filterChange(){
    var filters = {
      filtroUtilizzata: this.utilizzataFilter
    }
    bus.$emit("filtroRichiesteAlternanza", filters);
  }

  openCreationPage(params: any) {
    if (params.type === "nuovaRichiestaTirocinante") {
      router.push({
        name: "richiestaTirocinanti",
        params: {
          idIstituto: params.idIstituto,
          idAnnoScolastico: params.idAnnoScolastico,
          idIscrizioneAttivita: params.idIscrizioneAttivita
        }
      });
    } else if (params.type === "nuovaRichiestaTirocinanteEstivo") {
      router.push({
        name: "richiestaTirocinantiEstivi",
        params: {
          idIstituto: params.idIstituto,
          idAnnoScolastico: params.idAnnoScolastico,
          idIscrizioneAttivita: params.idIscrizioneAttivita
        }
      });
    } else if (params.type === "nuovaRichiestaTirocinanteFormativo") {
      router.push({
        name: "richiestaTirocinantiFormativi",
        params: {
          idIstituto: params.idIstituto,
          idAnnoScolastico: params.idAnnoScolastico,
          idIscrizioneAttivita: params.idIscrizioneAttivita
        }
      });
    }
  }

  deleteItem(idRichiesta: number) {
    if (confirm("Eliminare definitivamente la disponibilità selezionata?")) {
      if (this.params.type === "alternanza") {
        user
          .dispatchDeleteRichiestaAlternanza(this["$store"], idRichiesta)
          .then(() => {
            bus.$emit("refreshAlternanzaTable");
            bus.$emit(
              "successfullOperation",
              "Disponibilità cancellata con successo"
            );
          })
          .catch(error => {
            if (error.response.status === 403) {
              bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
              this["$router"].push("/login");
            } else {
              bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
            }
          });
      } else if (this.params.type === "tirociniEstivi") {
        user
          .dispatchDeleteRichiestaTirEstivo(this["$store"], idRichiesta)
          .then(() => {
            bus.$emit("refreshTirEstiviTable");
            bus.$emit(
              "successfullOperation",
              "Disponibilità cancellata con successo"
            );
          })
          .catch(error => {
            if (error.response.status === 403) {
              bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
              this["$router"].push("/login");
            } else {
              bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
            }
          });
      }
    }
  }

  changeAnnoScolastico() {
    bus.$emit("changeAnnoScolastico", this.annoScolasticoFilter);
  }

  loadAnniScolastici() {
    data
      .dispatchAnniScolastici(this["$store"])
      .then(result => {
        result.forEach((element: any) => {
          this.anniScolastici.push({
            //@ts-ignore
            nomeAnno: element.nomeAnnoScolastico,
            //@ts-ignore
            idAnno: element.idAnnoScolastico
          });
        });
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }

  created() {
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var token = localStorage.getItem("userToken");
    var parsedToken: any;
    if (token !== null) {
      parsedToken = userUtils.parseToken(token);
    }
    var payload = {
      idUtente: parsedToken.IdUtente,
      tipoSoggetto: parsedToken.IdTipoSoggetto,
      username: parsedToken.Username
    };
    user
      .dispatchSetUserInfo(this["$store"], payload)
      .then(() => {
        this.userInfo = user.readUserInfo(this["$store"]); 
      })

    this.loadAnniScolastici();
    this.annoScolasticoFilter = idAnnoScolastico;

    bus.$on("dataLoaded", () => {
      this.loadingData = false;
    });

    bus.$on("destroyIspezioneDialog", async () => {
      this.showReportDialog = false;
      await this.$nextTick();
      this.showReportDialog = true;
    });

    bus.$on("destroyReportDialog", async () => {
      this.showReportDialog = false;
      await this.$nextTick();
      this.showReportDialog = true;
    });

    bus.$on("destroyNoteAziendeDialog", async () => {
      this.showNoteAziendeDialog = false;
      await this.$nextTick();
      this.showNoteAziendeDialog = true;
    });
  }

  // bus.$emit("destroyIspezioneDialog");
}
